import React, { FC } from 'react';
import { GenExternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import { TypeMyAccountPageTranslations } from '@/utils/translations';
import {
  trackItemClickedEvent,
  CLICKED_ITEM_TYPES,
  PAGE_LOCATIONS,
  CTA_NAMES,
} from '@/utils/rudderstack';

export type OrderHistoryTileProps = {
  t: TypeMyAccountPageTranslations;
  userUuid: string;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
};

const OrderHistoryTile: FC<OrderHistoryTileProps> = ({
  t,
  userUuid,
  tile,
  locale,
}) => {
  const orderHistoryLink = constructLegacyCustomerPortalLink(locale, [
    userUuid,
    'order-history',
  ]);

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: orderHistoryLink,
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.ORDER_HISTORY_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      description={tile.description}
      titleDecorator={
        <GenExternalLink
          href={orderHistoryLink}
          cta={t.viewCta}
          onClick={sendItemClickedEvent}
        />
      }
    />
  );
};

export default React.memo(OrderHistoryTile);
